class Overflow {

    /**
     * @since 4.7.0
     * @method constructor
     */
    constructor() {
        // Declare and initialize
        this.selector = '[data-overflow]';

        // Run initialization
        this.init();
    }

    /**
     * Initialize the class.
     *
     * @method init
     * @since 4.18.0
     * @returns object The initialized map
     */
    init() {
        // If there are no countdowns, bail
        if (!$(this.selector).length) return;

        // Add classes to each of them
        $(this.selector).each(function () {

            // Declare and initialize
            let ele               = $(this)[0];
            let containerSelector = $(this).data('overflow-container');
            let container         = $(this).closest(containerSelector);

            // If no container, use the element itself
            container = 0 < container.length ? container[0] : ele;

            // Run the calculators
            let overflow      = ele.scrollWidth > container.offsetWidth;
            let selector      = $(this).data('overflow-target') || '';
            let target        = selector ? $(this).closest(selector) : $(this);
            let overflowClass = $(this).data('overflow-class') || 'overflowing';

            // Toggle class based on viewability
            if (overflow)
                target.addClass(overflowClass);

        });

        // Prevent leaks
        return;
    }

}

export default Overflow;